/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ShelvingUnit = createLucideIcon("shelving-unit", [
  ["path", { d: "M12 12V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "wiz68x" }],
  ["path", { d: "M16 20v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3", key: "1b59c4" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }],
  ["path", { d: "M4 12h16", key: "1lakjw" }],
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M4 4h16", key: "1bkgr1" }]
]);

export { ShelvingUnit as default };
//# sourceMappingURL=shelving-unit.js.map
